<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-row :gutter="12">
      <a-col :span="12" v-for="(collect,index) in collectList" :key="index" >
        <a-card :title="collect.postName" style="width: 300px">
          <template #extra><font color="red">{{collect.wage}}元</font></template>
          <p>收藏时间: {{collect.collectTime}}</p>
          <p>公司名称: {{collect.companyName}}</p>
        </a-card>
      </a-col>
    </a-row>
  </a-drawer>
</template>

<script>
import { queryCollectListById } from '@/api/biz/user'
export default {
  name: 'CollectForm',
  data () {
    return {
      formTitle: null,
      open: false,
      collectList: []
    }
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    getList(id) {
      this.open = true
      this.formTitle = '收藏记录'
      const param = { id: id }
      queryCollectListById(param).then(response => {
        this.collectList = response.data
      })
    },
    onClose () {
      this.open = false
    }
  }
}

</script>

<style scoped>

</style>
